import * as React from 'react';
import { IRestCardCheckListActivity } from '../../../../../../../types/rest/activity/IRestCardCheckListActivity';
import './_CardActivityCheckListAssigned.scss';
import { IActivityProps } from '../../../../boardDetails/activity/TabActivity/types';
import { TabActivityContext } from '../../../../boardDetails/activity/TabActivity/components/TabActivity/constants';
import { TActivity } from '../../../../../../../store/activities/types';
import {
    ActivityItemBody
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../../../../boardDetails/activity/TabActivity/components/ActivityHeader/ActivityHeader';
import {
    ActivityItemName
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemName/ActivityItemName';
import { CLASS_ACTIVITY_ITEM } from '../../../../boardDetails/activity/TabActivity/components/constants';
import { v4 as uuidv4 } from 'uuid';
import { markdown } from '../../../../../../../helper/markdownHelper';
import { msFileThumbnailStorage } from '../../../../../../../helper/authorisation/microsoft/storage/msThumbnail';
import { GOOGLE_SPACING } from '../../../../../../../const';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import { UsersTooltip } from '../../../../../base/components/UsersTooltip/UsersTooltip';
import { ERestActivityPropertyActionType } from '../../../../../../../types/rest/activity/IRestActivityBase';
import { CHECKLIST_ITEM_ASSIGNER_REMOVED } from './constants';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardActivityCheckListAssigned`) : null;

export function CardActivityCheckListAssigned({
    activity,
    userId,
}: IActivityProps<IRestCardCheckListActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { onOpenCard } = React.useContext(TabActivityContext);
    const { label, card } = activity as TActivity;
    const className = CLASS_ACTIVITY_ITEM + '__checklist-assigned';
    const [classUnique] = React.useState(className + '--' + uuidv4());
    const [checklistItemMarkdown, setChecklistItemMarkdown] = React.useState('');
    React.useEffect(() => {
        let checklistItemMarkdown = activity.checkListName;
        setChecklistItemMarkdown(markdown(checklistItemMarkdown));

        if (msFileThumbnailStorage.is()) {
            if (checklistItemMarkdown) {
                msFileThumbnailStorage.getSrcThumbnails(checklistItemMarkdown)
                    .then((text) => {
                        setChecklistItemMarkdown(markdown(text));
                    })
                    .catch(() => {});
            }
        }
    }, [activity]);

    return (
        <ActivityItemBody
            className={`
                ${className}
                ${classUnique}
            `}
            header={<ActivityHeader
                label={label}
                content={(activity.users.length > 1 || activity.users[0].permissionId !== userId) &&
                    <>
                        <UsersTooltip
                            users={activity.users.filter(user => user.permissionId !== userId).map(user => ({ sharedUser: user }))}
                            isNoEvents
                        />
                        {activity.propertyActionType === ERestActivityPropertyActionType.UPDATE &&
                            CHECKLIST_ITEM_ASSIGNER_REMOVED}
                    </>
                }
            />}
            activity={activity}
            onClick={() => onOpenCard(card.id, activity.id, 'checklists')}
        >
            <ActivityItemName
                isMarkdown
                style={{ height: GOOGLE_SPACING * 3 }}
                name={checklistItemMarkdown}
                tooltip={activity.newValue}
            />
        </ActivityItemBody>
    );
};
